import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { doc, getDoc, updateDoc, db, deleteDoc } from '../../../api/firebase';
import { Box, IconButton } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import DeleteDialog from '../../../components/DeleteDialog';
import { useSnackbar } from 'notistack';
import EditUserForm from './edit';
import ViewUser from './view';
import { userApi } from '../../../api/api-backend/user_api';

const UserManager = () => {
  const [user, setUser] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { userId } = useParams();
  const navigate = useNavigate();
  const [isDeleting, setIsDeleting] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    const fetchUser = async () => {
      try {
        console.log('Fetching user data...');
        console.log('User ID:', userId);
        const docRef = doc(db, 'users', userId);
        const docSnap = await getDoc(docRef);
        
        if (docSnap.exists()) {
          setUser(docSnap.data());
        } else {
          setError('User not found');
        }
      } catch (err) {
        setError('Error fetching organization data');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, [userId]);

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleCancel = () => {
    setIsEditing(false);
  };

  const handleDelete = () => {
    setIsDeleting(true);
  };

  const handleDeleteConfirm = async () => {
    try {
      console.log('Deleting user:', userId);
      await userApi.deleteUser(userId);
      setIsDeleting(false);
        enqueueSnackbar('User deleted successfully', { variant: 'success' });
      navigate('/admin/user'); // Redirect to organizations list
    } catch (err) {
      setError('Error deleting user');
      enqueueSnackbar('Error deleting user: ' + err.message, { variant: 'error' });
      console.error(err);
    }
  };

  const handleDeleteCancel = () => {
    setIsDeleting(false);
  };

  const handleSave = async (updatedData) => {
    try {
      const docRef = doc(db, 'users', userId);
      await updateDoc(docRef, updatedData);
      setUser(updatedData);
      setIsEditing(false);
    } catch (err) {
      setError('Error updating user data');
      console.error(err);
    }
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div>
        <IconButton onClick={() => navigate('/admin/user')} style={{ marginBottom: '20px' }}>
            <ArrowBack />
            <h4>Back</h4>
        </IconButton>
      {isEditing ? (
        <EditUserForm
          user={user}
          onSave={handleSave}
          onCancel={handleCancel}
        />
      ) : (
        <ViewUser
          user={user}
          onEdit={handleEdit}
          onDelete={handleDelete}
        />
      )}
        <DeleteDialog
            open={isDeleting}
            itemName={user?.name}
            onClose={handleDeleteCancel}
            onConfirm={handleDeleteConfirm}
            onCancel={handleDeleteCancel}
        />
    </div>
  );
};

export default UserManager;